import { render, staticRenderFns } from "./BuscadorModal.vue?vue&type=template&id=74335f48&scoped=true"
import script from "./BuscadorModal.vue?vue&type=script&lang=js"
export * from "./BuscadorModal.vue?vue&type=script&lang=js"
import style0 from "./BuscadorModal.vue?vue&type=style&index=0&id=74335f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74335f48",
  null
  
)

export default component.exports